// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ReorderHover: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 14 13"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="14"
            height="13"
            fill="currentColor"
        >
            <path
                d="M227.035077,405.674492 C226.793036,405.574523 226.512163,405.629211 226.326665,405.817199 L224.958857,407.198332 C223.86943,406.221367 222.455857,405.625 220.936672,405.625 C218.255757,405.625 215.859994,407.438164 215.112046,410.035547 C215.011308,410.382812 215.209263,410.746484 215.55372,410.847656 C215.900614,410.951043 216.259423,410.748535 216.359348,410.40168 C216.947795,408.36211 218.829852,406.9375 220.936672,406.9375 C222.104359,406.9375 223.193786,407.386484 224.042742,408.124219 L222.427965,409.754727 C222.24179,409.942715 222.186791,410.224766 222.286635,410.470039 C222.387345,410.715285 222.624322,410.875 222.887539,410.875 L226.784343,410.875 C227.143396,410.850391 227.435859,410.582422 227.435859,410.21875 L227.435859,406.28125 C227.435859,406.015469 227.278796,405.776211 227.035077,405.674492 Z M226.317458,412.627735 C225.971376,412.525195 225.611755,412.726008 225.511829,413.073711 C224.925548,415.13789 223.043491,416.5625 220.9123,416.5625 C219.744613,416.5625 218.654374,416.113515 217.80623,415.375508 L219.420736,413.745273 C219.606911,413.557285 219.661504,413.279609 219.561633,413.034336 C219.485186,412.789062 219.249591,412.625 218.962544,412.625 L215.088757,412.625 C214.729948,412.625 214.435859,412.918672 214.435859,413.280976 L214.435859,417.218476 C214.435859,417.48423 214.594115,417.723515 214.836913,417.825234 C214.917341,417.858594 215.00183,417.875 215.085778,417.875 C215.255028,417.875 215.421028,417.808336 215.545325,417.682746 L216.913133,416.30134 C218.001206,417.278907 219.417487,417.875 220.9123,417.875 C223.593215,417.875 225.987083,416.061836 226.737198,413.464453 C226.861765,413.092578 226.661373,412.753516 226.317458,412.627735 L226.317458,412.627735 Z"
                transform="translate(-214 -405)"
            />
        </svg>
    );
};

export default React.memo(ReorderHover);
